<template>
  <div class="panel-card" id="base-plan">

    <!-- Panel Header -->
    <div class="panel-header">
      <div class="panel-header-left">
        <div class="panel-icon"><i class="fa fa-calendar-alt"></i></div>
        <div>
          <div class="panel-title">Base Plan</div>
          <div class="panel-sub">Schedule &amp; Holidays</div>
        </div>
      </div>
      <div class="panel-header-right">
        <template v-if="currentUser.u.roles == 'admin'">
          <label class="days-label">Show for</label>
          <input type="number" v-model="no_of_days" class="days-input" />
          <span class="days-unit">days</span>
        </template>
        <button class="btn-back" @click="goback()">
          <i class="fa fa-arrow-left"></i> Back
        </button>
        <button
          v-if="activeTab === 'baseplan' && currentUser.u.roles == 'admin'"
          class="btn-save-plan"
          ref="kt_submit_base_plan"
          @click="saveBasePlans()"
        >
          <i class="fa fa-check"></i> Save
        </button>
      </div>
    </div>

    <!-- Tab Bar -->
    <div class="tab-bar">
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'baseplan' }"
        @click="activeTab = 'baseplan'"
      >
        <i class="fa fa-clock"></i> Base Plan
      </button>
      <button
        class="tab-btn"
        :class="{ active: activeTab === 'holidays' }"
        @click="activeTab = 'holidays'"
      >
        <i class="fa fa-calendar-times"></i> Holidays
      </button>
    </div>

    <!-- ─── Base Plan Tab ─── -->
    <div v-show="activeTab === 'baseplan'">

      <!-- Add-slot form (admin only) -->
      <div class="add-form" v-if="currentUser.u.roles == 'admin'">
        <div class="add-form-field">
          <label class="form-lbl">Weekday</label>
          <select class="form-ctrl" v-model="plan.day">
            <option value="">Select</option>
            <option value="all">All days</option>
            <option v-for="(w, i) in weekdays" :key="i" :value="w">{{ w }}</option>
          </select>
        </div>
        <div class="add-form-field">
          <label class="form-lbl">Start Time</label>
          <input type="time" v-model="plan.start_time" class="form-ctrl" />
        </div>
        <div class="add-form-field">
          <label class="form-lbl">End Time</label>
          <input type="time" v-model="plan.end_time" class="form-ctrl" />
        </div>
        <div class="add-form-field narrow">
          <label class="form-lbl">Interval (min)</label>
          <input type="number" min="1" v-model="plan.interval" class="form-ctrl" />
        </div>
        <div class="add-form-field narrow">
          <label class="form-lbl">Applicants</label>
          <input type="number" min="1" v-model="plan.no_of_applicants" class="form-ctrl" />
        </div>
        <div class="add-form-action">
          <button
            class="btn-add"
            @click="planpush(1)"
            v-if="add_status == 0 && plan.day != 'all'"
          ><i class="fa fa-plus"></i> Add</button>
          <button
            class="btn-add"
            @click="addallinall()"
            v-if="plan.day == 'all'"
          ><i class="fa fa-plus"></i> Add All</button>
        </div>
      </div>

      <!-- Schedule Table -->
      <div class="table-wrap">
        <table class="bp-table">
          <thead>
            <tr>
              <th style="width:130px">Start Time</th>
              <th style="width:100px">Interval</th>
              <th style="width:130px">End Time</th>
              <th style="width:130px">Applicants</th>
              <th
                v-if="currentUser.u.roles == 'admin'"
                style="width:100px; text-align:right"
              >Action</th>
            </tr>
          </thead>
          <tbody v-for="day in weekdays" :key="day">
            <tr class="day-group-row">
              <td :colspan="currentUser.u.roles == 'admin' ? 5 : 4">{{ day }}</td>
            </tr>
            <tr
              v-for="(item, index) in baseplan[day]"
              :key="day + '_' + index"
              :class="{ 'row-error': item.error == 1 }"
            >
              <td>
                <input
                  type="time"
                  :id="day + '_start_time_' + index"
                  v-model="item.start_time"
                  class="cell-input"
                />
              </td>
              <td>
                <input
                  type="number"
                  min="1"
                  :id="day + '_interval_' + index"
                  v-model="item.interval"
                  class="cell-input"
                />
              </td>
              <td>
                <input
                  type="time"
                  :id="day + '_end_time_' + index"
                  v-model="item.end_time"
                  class="cell-input"
                />
              </td>
              <td>
                <input
                  type="number"
                  min="1"
                  :id="day + '_no_of_applicants_' + index"
                  v-model="item.no_of_applicants"
                  class="cell-input"
                />
              </td>
              <td v-if="currentUser.u.roles == 'admin'" class="action-cell">
                <button
                  class="btn-row-add"
                  v-if="baseplan[day].length - 1 == index"
                  @click="planpush(2, item, item.day)"
                ><i class="fa fa-plus"></i></button>
                <button
                  class="btn-row-delete"
                  @click="removeplan(item.day, index)"
                ><i class="fa fa-trash"></i></button>
              </td>
            </tr>
            <tr v-if="baseplan[day].length == 0" class="empty-row">
              <td :colspan="currentUser.u.roles == 'admin' ? 5 : 4">No schedules set</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- ─── Holidays Tab ─── -->
    <div v-show="activeTab === 'holidays'">

      <!-- Add-holiday form (admin only) -->
      <div class="add-form" v-if="currentUser.u.roles == 'admin'">
        <div class="add-form-field">
          <label class="form-lbl">Date <span class="req">*</span></label>
          <input type="date" v-model="holiday.start" class="form-ctrl" />
        </div>
        <div class="add-form-field">
          <label class="form-lbl">Remarks</label>
          <input type="text" v-model="holiday.remarks" class="form-ctrl" placeholder="Optional" />
        </div>
        <div class="add-form-field narrow check-field">
          <label class="form-lbl">Set Time</label>
          <label class="toggle-wrap">
            <input type="checkbox" v-model="holiday.set_time" class="toggle-input" />
            <span class="toggle-slider"></span>
          </label>
        </div>
        <div class="add-form-field" v-if="holiday.set_time">
          <label class="form-lbl">Start Time</label>
          <input type="time" v-model="holiday.start_time" class="form-ctrl" />
        </div>
        <div class="add-form-field" v-if="holiday.set_time">
          <label class="form-lbl">End Time</label>
          <input type="time" v-model="holiday.end_time" class="form-ctrl" />
        </div>
        <div class="add-form-action">
          <button class="btn-add" @click="pushHoliday">
            <i class="fa fa-plus"></i> Add
          </button>
        </div>
      </div>

      <div class="holiday-note" v-if="currentUser.u.roles == 'admin' && holiday.start">
        <i class="fa fa-info-circle"></i>
        {{ holiday.set_time
          ? `Closed on ${holiday.start} from ${holiday.start_time || '...'} to ${holiday.end_time || '...'}.`
          : `Closed for the entire day on ${holiday.start}.` }}
      </div>

      <!-- Holidays Table -->
      <div class="table-wrap">
        <table class="bp-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Remarks</th>
              <th style="width:120px">Start Time</th>
              <th style="width:120px">End Time</th>
              <th
                v-if="currentUser.u.roles == 'admin'"
                style="width:70px; text-align:right"
              >Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(h, i) in getHolidays" :key="i">
              <td>{{ dateFormat(h.holiday_date) }}</td>
              <td>{{ h.remarks }}</td>
              <td>{{ h.start_time || '—' }}</td>
              <td>{{ h.end_time || '—' }}</td>
              <td v-if="currentUser.u.roles == 'admin'" class="action-cell">
                <button class="btn-row-delete" @click="removeHoliday(i, h)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!getHolidays || getHolidays.length == 0" class="empty-row">
              <td :colspan="currentUser.u.roles == 'admin' ? 5 : 4">No holidays configured</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";

import {
  STORE_APPOINTMENT_NEW_BASE_PLAN,
  STORE_HOLIDAY,
  FETCH_HOLIDAYS,
  REMOVE_HOLIDAYS,
  FETCH_NEW_BASE_PLAN,
  CHECK_HOLIDAY,
  FETCH_LOCATION_NEW_BASE_PLAN,
  FETCH_LOCATION_HOLIDAYS
} from "@/core/services/store/actions.type";
import moment from "moment";

import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
export default {
  computed: {
    ...mapGetters(["currentUser", "getHolidays"])
  },
  data() {
    return {
      activeTab: "baseplan",
      plan: {
        start_time: "",
        end_time: "",
        interval: 0,
        no_of_applicants: 0,
        day: "",
        error: 0,
        is_woking_time: true
      },
      temp_start_time: "",
      temp_end_time: "",
      old_temp_start_time: 0,
      results: [],

      breadCrumbs: [
        {
          id: 1,
          title: "Dashboard",
          route: "client.dashboard"
        },
        {
          id: 2,
          title: "New Base Plan",
          route: ""
        }
      ],
      weekdays: moment.weekdays(),
      weekday: "",
      baseplan: {
        Sunday: [],
        Monday: [],
        Tuesday: [],
        Wednesday: [],
        Thursday: [],
        Friday: [],
        Saturday: []
      },
      no_of_days: 60,
      holidays: [],
      add_status: 1,
      error_status: 1,
      holiday: {
        start: "",
        end: "",
        remarks: "",
        set_time: 0,
        start_time: "",
        end_time: ""
      }
    };
  },
  created() {
    if (this.$route.params.client == "sp") {
      this.getLocationwiseholidays();
      this.getLocationwisebasePlan();
      this.breadCrumbs[1].title =
        this.breadCrumbs[1].title + " (" + this.$route.params.location + ")";
    } else {
      this.getholidays();
      this.fetchbasePlan();
    }
    this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
  },
  methods: {
    pushHoliday() {
      if (this.holiday.start == "") {
        this.$toastr.w("Please enter the required fields");
        return;
      }
      let holiday = { ...this.holiday };
      if (holiday.end == "") {
        holiday.end = holiday.start;
      }
      var formData = {
        holiday: holiday,
        check: 0,
        client: this.$route.params.client,
        location_id:
          this.$route.params.client == "sp"
            ? this.$route.params.location_id
            : null
      };

      Swal.fire({
        title: "Are you sure?",
        text: "You want to add this date",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(CHECK_HOLIDAY, formData)
            .then(res => {
              if (res.code == 200) {
                this.$store
                  .dispatch(STORE_HOLIDAY, formData)
                  .then(res => {
                    this.$toastr.s(res.msg);
                    if (this.$route.params.client == "sp") {
                      this.getLocationwiseholidays();
                    } else {
                      this.getholidays();
                    }
                    this.resetHoliday();
                  })
                  .catch(errs => {
                    this.$toastr.e(errs.detail);
                  });
              } else {
                Swal.fire({
                  title: res.msg,
                  icon: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#3085d6",
                  cancelButtonColor: "#d33",
                  confirmButtonText: "Yes",
                  cancelButtonText: "No"
                }).then(result => {
                  if (result.isConfirmed) {
                    this.$store
                      .dispatch(STORE_HOLIDAY, formData)
                      .then(res => {
                        this.$toastr.s(res.msg);
                        if (this.$route.params.client == "sp") {
                          this.getLocationwiseholidays();
                        } else {
                          this.getholidays();
                        }
                        this.resetHoliday();
                      })
                      .catch(() => {
                        this.$toastr.e("Something went wrong !");
                      });
                  }
                });
              }
            })
            .catch(() => {
              this.$toastr.e("Something went wrong !");
            });
        }
      });
    },
    fetchbasePlan() {
      this.$store
        .dispatch(FETCH_NEW_BASE_PLAN)
        .then(res => {
          let baseplan = res.data;
          this.no_of_days = res.no_of_days == "" ? 60 : res.no_of_days;

          baseplan.forEach(base => {
            if (base.day == "Sunday" && base.detail != []) {
              this.baseplan.Sunday = base.detail;
            }
            if (base.day == "Monday" && base.detail != []) {
              this.baseplan.Monday = base.detail;
            }
            if (base.day == "Tuesday" && base.detail != []) {
              this.baseplan.Tuesday = base.detail;
            }
            if (base.day == "Wednesday" && base.detail != []) {
              this.baseplan.Wednesday = base.detail;
            }
            if (base.day == "Thursday" && base.detail != []) {
              this.baseplan.Thursday = base.detail;
            }
            if (base.day == "Friday" && base.detail != []) {
              this.baseplan.Friday = base.detail;
            }
            if (base.day == "Saturday" && base.detail != []) {
              this.baseplan.Saturday = base.detail;
            }
          });
        })
        .catch(() => {});
    },
    getLocationwisebasePlan() {
      this.$store
        .dispatch(FETCH_LOCATION_NEW_BASE_PLAN, this.$route.params.location_id)
        .then(res => {
          let baseplan = res.data;
          this.no_of_days = res.no_of_days == "" ? 60 : res.no_of_days;

          baseplan.forEach(base => {
            if (base.day == "Sunday" && base.detail != []) {
              this.baseplan.Sunday = base.detail;
            }
            if (base.day == "Monday" && base.detail != []) {
              this.baseplan.Monday = base.detail;
            }
            if (base.day == "Tuesday" && base.detail != []) {
              this.baseplan.Tuesday = base.detail;
            }
            if (base.day == "Wednesday" && base.detail != []) {
              this.baseplan.Wednesday = base.detail;
            }
            if (base.day == "Thursday" && base.detail != []) {
              this.baseplan.Thursday = base.detail;
            }
            if (base.day == "Friday" && base.detail != []) {
              this.baseplan.Friday = base.detail;
            }
            if (base.day == "Saturday" && base.detail != []) {
              this.baseplan.Saturday = base.detail;
            }
          });
        })
        .catch(() => {});
    },
    resetHoliday() {
      this.holiday = {
        start: "",
        end: "",
        remarks: "",
        set_time: 0,
        start_time: "",
        end_time: ""
      };
    },
    getholidays() {
      this.$store.dispatch(FETCH_HOLIDAYS);
      return;
    },
    getLocationwiseholidays() {
      this.$store.dispatch(
        FETCH_LOCATION_HOLIDAYS,
        this.$route.params.location_id
      );
      return;
    },
    removeHoliday(i, data) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to delete ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(REMOVE_HOLIDAYS, data.id)
            .then(res => {
              this.$toastr.s(res.msg);
              if (this.$route.params.client == "sp") {
                this.getLocationwiseholidays();
              } else {
                this.getholidays();
              }
            })
            .catch(errs => {
              this.$toastr.e(errs.detail);
            });
        }
      });
    },
    saveBasePlans() {
      var baseplan = { ...this.baseplan };
      baseplan = Object.values(baseplan);
      let error_status = 0;
      let msg = "Please fill all the value";
      baseplan.filter(word => {
        word.filter((v, i) => {
          if (v.error == 1) {
            if (v.interval == "") {
              let x = `${v.day}_interval_${i}`;
              document.getElementById(x).focus();
              error_status = 1;
              return v;
            }
            if (v.start_time == "") {
              let x = `${v.day}_start_time_${i}`;
              document.getElementById(x).focus();
              error_status = 1;
              return v;
            }
            if (v.end_time == "") {
              let x = `${v.day}_end_time_${i}`;
              document.getElementById(x).focus();
              error_status = 1;
              return v;
            }
            if (v.no_of_applicants == "") {
              let x = `${v.day}_no_of_applicants_${i}`;
              document.getElementById(x).focus();
              error_status = 1;
              return v;
            }
          }
          if (v.interval <= 0) {
            let x = `${v.day}_interval_${i}`;
            document.getElementById(x).focus();
            error_status = 1;
            msg = "Value must be greater than zero";
            return v;
          }
          if (v.no_of_applicants <= 0) {
            let x = `${v.day}_no_of_applicants_${i}`;
            document.getElementById(x).focus();
            msg = "Value must be greater than zero";
            error_status = 1;
            return v;
          }
        });
        return word;
      });
      if (error_status) {
        this.$toastr.w(msg);
        return 0;
      }
      var formData = {
        data: this.baseplan,
        no_of_days: this.no_of_days,
        client: this.$route.params.client,
        location_id:
          this.$route.params.client == "sp"
            ? this.$route.params.location_id
            : null
      };

      const submitButton = this.$refs["kt_submit_base_plan"];
      submitButton.disabled = true;
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");
      if (this.error_status) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.disabled = false;
        this.$toastr.w("Please fill all the value");
        return 0;
      }
      this.$store
        .dispatch(STORE_APPOINTMENT_NEW_BASE_PLAN, formData)
        .then(res => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
          this.$toastr.s(res.msg);
          if (this.$route.params.client == "sp") {
            this.getLocationwisebasePlan();
          } else {
            this.fetchbasePlan();
          }
        })
        .catch(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
          submitButton.disabled = false;
          this.$toastr.e("Something went wrong !");
        });
    },
    removeplan(weekday, index) {
      switch (weekday) {
        case "Sunday":
          this.baseplan.Sunday.splice(index, 1);
          break;
        case "Monday":
          this.baseplan.Monday.splice(index, 1);
          break;
        case "Tuesday":
          this.baseplan.Tuesday.splice(index, 1);
          break;
        case "Wednesday":
          this.baseplan.Wednesday.splice(index, 1);
          break;
        case "Thursday":
          this.baseplan.Thursday.splice(index, 1);
          break;
        case "Friday":
          this.baseplan.Friday.splice(index, 1);
          break;
        case "Saturday":
          this.baseplan.Saturday.splice(index, 1);
          break;
        default:
      }
    },
    checkPlan(w, plan, status = 0) {
      let plans = [];
      switch (w) {
        case "Sunday":
          plans = this.baseplan.Sunday;
          break;
        case "Monday":
          plans = this.baseplan.Monday;
          break;
        case "Tuesday":
          plans = this.baseplan.Tuesday;
          break;
        case "Wednesday":
          plans = this.baseplan.Wednesday;
          break;
        case "Thursday":
          plans = this.baseplan.Thursday;
          break;
        case "Friday":
          plans = this.baseplan.Friday;
          break;
        case "Saturday":
          plans = this.baseplan.Saturday;
          break;
        default:
      }
      if (status) {
        return plans.length;
      }
      if (plans.length > 0) {
        return plans.filter(p => p.start_time == plan.start_time);
      } else {
        return -1;
      }
    },
    addallinall() {
      for (const property in this.baseplan) {
        let check_date = this.checkPlan(property, this.plan);
        if (check_date != -1 && check_date.length != 0) {
          this.$toastr.w("Time already added");
          return 0;
        }
      }

      let sun = { ...this.plan };
      let mon = { ...this.plan };
      let tue = { ...this.plan };
      let wed = { ...this.plan };
      let thu = { ...this.plan };
      let fri = { ...this.plan };
      let sat = { ...this.plan };

      sun.day = "Sunday";
      this.baseplan.Sunday.push(sun);
      mon.day = "Monday";
      this.baseplan.Monday.push(mon);
      tue.day = "Tuesday";
      this.baseplan.Tuesday.push(tue);
      wed.day = "Wednesday";
      this.baseplan.Wednesday.push(wed);
      thu.day = "Thursday";
      this.baseplan.Thursday.push(thu);
      fri.day = "Friday";
      this.baseplan.Friday.push(fri);
      sat.day = "Saturday";
      this.baseplan.Saturday.push(sat);
    },
    planpush(val, data = null, weekday = "") {
      let plan = null;
      let w = "";
      if (val == 1) {
        plan = { ...this.plan };
        if (
          plan.start_time == "" ||
          plan.end_time == "" ||
          plan.interval == 0 ||
          plan.no_of_applicants == 0 ||
          plan.day == ""
        ) {
          this.$toastr.w("Please fill all the value");
          return 0;
        }
        w = this.plan.day;
      } else {
        data = { ...data };
        let temp_start_time = this.$moment(data.end_time, "HH:mm");
        data.start_time = this.$moment(temp_start_time, "HH:mm").format(
          "HH:mm"
        );
        data.end_time = "";
        plan = data;
        w = weekday;
      }
      let check_date = this.checkPlan(w, plan);
      if (check_date != -1 && check_date.length != 0) {
        this.$toastr.w("Time already added");
        return 0;
      }

      switch (w) {
        case "Sunday":
          this.baseplan.Sunday.push(plan);
          break;
        case "Monday":
          this.baseplan.Monday.push(plan);
          break;
        case "Tuesday":
          this.baseplan.Tuesday.push(plan);
          break;
        case "Wednesday":
          this.baseplan.Wednesday.push(plan);
          break;
        case "Thursday":
          this.baseplan.Thursday.push(plan);
          break;
        case "Friday":
          this.baseplan.Friday.push(plan);
          break;
        case "Saturday":
          this.baseplan.Saturday.push(plan);
          break;
        default:
      }

      this.add_status = 1;
    },
    reset() {
      this.plan = {
        start_time: "",
        end_time: "",
        interval: 0,
        no_of_applicants: 0,
        weekday: ""
      };
    },
    goback() {
      this.$router.go(-1);
    }
  },
  watch: {
    "plan.day": function(val) {
      if (val != "") {
        this.add_status = this.checkPlan(val, null, 1);
        return 0;
      }
      this.add_status = 1;
    },
    baseplan: {
      handler(values) {
        for (const property in values) {
          for (let i = 0; i < values[property].length; i++) {
            if (
              values[property][i].start_time == "" ||
              values[property][i].end_time == "" ||
              values[property][i].interval == 0 ||
              values[property][i].no_of_applicants == 0
            ) {
              values[property][i].error = 1;
            } else {
              values[property][i].error = 0;
            }
            if (values[property][i].error == 1) {
              this.error_status = 1;
            } else {
              this.error_status = 0;
            }
          }
        }
      },
      deep: true
    }
  }
};
</script>

<style lang="scss" scoped>
/* ── Panel card ── */
.panel-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(13, 27, 62, 0.08);
  font-family: 'Segoe UI', sans-serif;
  overflow: clip;
  margin-bottom: 40px;
}

/* ── Panel header ── */
.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-bottom: 1px solid #eef0f6;
  background: #fafbfd;
  flex-wrap: wrap;
  gap: 8px;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.panel-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #389ad4;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 14px;
  font-weight: 700;
  color: #0d1b3e;
}

.panel-sub {
  font-size: 11px;
  color: #8a94a6;
}

.panel-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.days-label {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
  white-space: nowrap;
  margin: 0;
}

.days-input {
  width: 60px;
  height: 32px;
  border: 1.5px solid #dde2ec;
  border-radius: 6px;
  padding: 0 8px;
  font-size: 12px;
  font-family: 'Segoe UI', sans-serif;
  color: #0d1b3e;
  text-align: center;
  outline: none;
  -moz-appearance: textfield;
  appearance: textfield;

  &:focus { border-color: #389ad4; }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
}

.days-unit {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}

.btn-back {
  height: 32px;
  padding: 0 14px;
  border: 1.5px solid #dde2ec;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Segoe UI', sans-serif;
  color: #4a5568;
  background: #fff;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: border-color 0.15s, color 0.15s;

  &:hover { border-color: #389ad4; color: #389ad4; }
}

.btn-save-plan {
  height: 32px;
  padding: 0 14px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Segoe UI', sans-serif;
  color: #fff;
  background: #276749;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s;

  &:hover { background: #1d5230; }
  &:disabled { opacity: 0.6; cursor: not-allowed; }
}

/* ── Tab bar ── */
.tab-bar {
  display: flex;
  border-bottom: 1px solid #eef0f6;
  padding: 0 20px;
  background: #fff;
}

.tab-btn {
  height: 40px;
  padding: 0 16px;
  border: none;
  background: none;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Segoe UI', sans-serif;
  color: #8a94a6;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: color 0.15s, border-color 0.15s;

  &.active {
    color: #389ad4;
    border-bottom-color: #389ad4;
    font-weight: 600;
  }

  &:hover:not(.active) { color: #389ad4; }
}

/* ── Add form toolbar ── */
.add-form {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  padding: 12px 20px;
  background: #f7f9fc;
  border-bottom: 1px solid #eef0f6;
  flex-wrap: wrap;
}

.add-form-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 110px;

  &.narrow { flex: 0 0 90px; min-width: 90px; }
  &.check-field { flex: 0 0 80px; min-width: 80px; }
}

.form-lbl {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #8a94a6;
  margin: 0;

  .req { color: #e53e3e; margin-left: 2px; }
}

.form-ctrl {
  height: 32px;
  border: 1.5px solid #dde2ec;
  border-radius: 6px;
  padding: 0 10px;
  font-size: 12px;
  font-family: 'Segoe UI', sans-serif;
  color: #0d1b3e;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  background: #fff;
  -moz-appearance: textfield;
  appearance: textfield;

  &:focus { border-color: #389ad4; }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
}

.add-form-action {
  display: flex;
  align-items: flex-end;
}

.btn-add {
  height: 32px;
  padding: 0 16px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'Segoe UI', sans-serif;
  color: #fff;
  background: #F58020;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  transition: background 0.15s;

  &:hover { background: #d96b10; }
}

/* ── Toggle switch ── */
.toggle-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  height: 32px;
  margin: 0;
}

.toggle-input {
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + .toggle-slider { background: #276749; }
  &:checked + .toggle-slider::before { transform: translateX(16px); }
}

.toggle-slider {
  width: 36px;
  height: 20px;
  background: #cbd5e0;
  border-radius: 10px;
  position: relative;
  transition: background 0.2s;

  &::before {
    content: '';
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #fff;
    top: 3px;
    left: 3px;
    transition: transform 0.2s;
  }
}

/* ── Table ── */
.table-wrap {
  overflow-x: auto;
  overflow-y: auto;
  max-height: calc(100vh - 280px);
}

.bp-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 13px;
  font-family: 'Segoe UI', sans-serif;

  thead tr th {
    position: sticky;
    top: 0;
    z-index: 2;
    background: #f0f4fa;
    padding: 8px 12px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #6b7280;
    border-bottom: 1px solid #dde4f5;
    white-space: nowrap;
  }

  tbody tr td {
    padding: 5px 12px;
    border-bottom: 1px solid #f0f2f8;
    color: #1a2340;
    vertical-align: middle;
  }

  .day-group-row td {
    background: #eef4fb;
    color: #1a5276;
    font-size: 11px;
    font-weight: 700;
    padding: 5px 12px;
    letter-spacing: 0.5px;
    border-bottom: none;
    text-transform: uppercase;
  }

  .empty-row td {
    color: #a0aab8;
    font-size: 12px;
    font-style: italic;
    text-align: center;
    padding: 8px 12px;
  }

  .row-error {
    background: #fef0f0 !important;
  }

  .action-cell {
    text-align: right;
    overflow: visible;
    white-space: nowrap;
  }
}

.cell-input {
  height: 30px;
  border: 1.5px solid #dde2ec;
  border-radius: 5px;
  padding: 0 6px;
  font-size: 12px;
  font-family: 'Segoe UI', sans-serif;
  color: #0d1b3e;
  width: 100%;
  box-sizing: border-box;
  outline: none;
  background: #fff;
  -moz-appearance: textfield;
  appearance: textfield;

  &:focus { border-color: #389ad4; }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
  }
}

.btn-row-add {
  height: 26px;
  width: 26px;
  border: 1.5px solid #276749;
  border-radius: 5px;
  font-size: 10px;
  color: #276749;
  background: #f0fdf4;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
  margin-right: 4px;

  &:hover { background: #276749; color: #fff; }
}

.btn-row-delete {
  height: 26px;
  width: 26px;
  border: 1.5px solid #e53e3e;
  border-radius: 5px;
  font-size: 10px;
  color: #e53e3e;
  background: #fff5f5;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;

  &:hover { background: #e53e3e; color: #fff; }
}

/* ── Holiday note ── */
.holiday-note {
  margin: 10px 20px;
  padding: 8px 12px;
  background: #fffbeb;
  border: 1px solid #f6e05e;
  border-radius: 6px;
  font-size: 12px;
  color: #744210;
  display: flex;
  align-items: flex-start;
  gap: 8px;

  i { margin-top: 1px; flex-shrink: 0; }
}
</style>

<style>
.swal2-popup .swal2-icon {
  margin-left: 39% !important;
}
</style>
